export default "__VITE_ASSET__fdAQ1Hct__"